var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { memo } from "react";
var SvgFoglieIcon = function SvgFoglieIcon(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 121 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.157 72.195c-5.338-13.606-17.94-23.82-33.478-25.328C23.14 45.36 8.792 52.937.934 65.253c5.338 13.606 17.94 23.82 33.478 25.327 15.539 1.508 29.887-6.069 37.745-18.385Z",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.157 72.195c13.614-5.336 23.834-17.93 25.343-33.46 1.508-15.549-6.073-29.869-18.397-37.723-13.613 5.335-23.834 17.93-25.342 33.46C52.253 50 59.834 64.34 72.157 72.194Z",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.73 126.757c5.854-13.388 4.167-29.513-5.756-41.571-9.922-12.06-25.421-16.839-39.71-13.686-5.854 13.388-4.167 29.513 5.756 41.572 9.922 12.058 25.421 16.838 39.71 13.685Z",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })));
};
var Memo = /*#__PURE__*/memo(SvgFoglieIcon);
export { Memo as ReactComponent };
export default "/_next/static/svg/c1f28cef97550f981c9688c115ebafb3.svg";